<app-modal
  [options]="modalOptions"
  (closeClick)="dialogRef.close()"
  [disableActions]="isPositiveDisabled()"
  (positiveClick)="onPositiveClick()"
  (negativeClick)="onNegativeClick()"
  [isSaving]="isSaving"
>
  <app-modal-steps
    modalAside
    [steps]="steps"
    [currentIndex]="selectedTabIndex"
    [furthestStepIndex]="furthestStepIndex"
    (stepChange)="onTabIndexChange($event)"
  ></app-modal-steps>

  @switch (selectedTabIndex) {
    <!-- ── Tab 1: Details ── -->
    @case (0) {
      <section class="modal-panel">
        <header class="modal-panel__header">
          <h5 class="modal-panel__title">
            {{ 'HUBS.STEP_DETAILS' | translate }}
          </h5>
        </header>

        <div class="modal-panel__body" (focusin)="scrollFieldIntoView($event)">
          <form class="field__form" [formGroup]="formGroup">
            <div class="field__group">
              <label class="field__label field__label--sm" for="hub-name">
                {{ 'HUBS.NAME' | translate }}
                <span class="field__right-label field__right-label--error"
                  >*</span
                >
              </label>
              <input
                id="hub-name"
                formControlName="name"
                class="field__input field__input--sm"
                [placeholder]="'HUBS.NAME_PLACEHOLDER' | translate"
              />
              <app-field-error
                [control]="formGroup.get('name')"
              ></app-field-error>
            </div>

            <div class="field__group">
              <label
                class="field__label field__label--sm"
                for="hub-description"
              >
                {{ 'HUBS.DESCRIPTION' | translate }}
                <span class="field__right-label field__right-label--error"
                  >*</span
                >
              </label>
              <textarea
                id="hub-description"
                formControlName="description"
                class="field__input field__input--sm"
                rows="2"
                [placeholder]="'HUBS.DESCRIPTION_PLACEHOLDER' | translate"
              ></textarea>
              <app-field-error
                [control]="formGroup.get('description')"
              ></app-field-error>
            </div>

            <div class="field__group">
              <label class="field__label field__label--sm">
                {{ 'HUBS.ABOUT' | translate }}
              </label>
              <p class="field__hint">{{ 'HUBS.ABOUT_HINT' | translate }}</p>
              <quill-editor
                formControlName="about"
                [modules]="richTextModules"
                [formats]="richTextFormats"
                [placeholder]="'HUBS.ABOUT_PLACEHOLDER' | translate"
              ></quill-editor>
            </div>

            <div class="field__row">
              <div class="field__group">
                <label
                  class="field__label field__label--sm"
                  id="label-hub-privacy"
                >
                  {{ 'HUBS.PRIVACY_LABEL' | translate }}
                  <span class="field__right-label field__right-label--error"
                    >*</span
                  >
                </label>
                <mat-select
                  formControlName="privacy"
                  class="field__input field__input--sm"
                  aria-labelledby="label-hub-privacy"
                >
                  <mat-option [value]="privacyTypes.PUBLIC">
                    {{ 'HUBS.PRIVACY_PUBLIC' | translate }}
                  </mat-option>
                  <mat-option [value]="privacyTypes.INVITED_ONLY">
                    {{ 'HUBS.PRIVACY_PRIVATE' | translate }}
                  </mat-option>
                </mat-select>
                <app-field-error
                  [control]="formGroup.get('privacy')"
                ></app-field-error>
              </div>

              <div class="field__group">
                <label
                  class="field__label field__label--sm"
                  id="label-hub-type"
                >
                  {{ 'HUBS.TYPE_LABEL' | translate }}
                  <span class="field__right-label field__right-label--error"
                    >*</span
                  >
                </label>
                <mat-select
                  formControlName="hubType"
                  class="field__input field__input--sm"
                  aria-labelledby="label-hub-type"
                >
                  @for (t of hubTypes; track t) {
                    <mat-option [value]="t">
                      {{ 'HUBS.LABEL_' + t | translate }}
                    </mat-option>
                  }
                </mat-select>
                <app-field-error
                  [control]="formGroup.get('hubType')"
                ></app-field-error>
              </div>
            </div>
          </form>
        </div>
      </section>
    }

    <!-- ── Tab 2: Settings ── -->
    @case (1) {
      <section class="modal-panel">
        <header class="modal-panel__header">
          <h5 class="modal-panel__title">
            {{ 'HUBS.STEP_SETTINGS' | translate }}
          </h5>
        </header>

        <div class="modal-panel__body" (focusin)="scrollFieldIntoView($event)">
          <form class="field__form" [formGroup]="formGroup">
            <div class="field__row">
              <div class="field__group">
                <label
                  class="field__label field__label--sm"
                  for="hub-campus-slug"
                >
                  {{ 'HUBS.CAMPUS_SLUG' | translate }}
                </label>
                <p class="field__hint">
                  {{ 'HUBS.CAMPUS_SLUG_HINT' | translate }}
                </p>
                <input
                  id="hub-campus-slug"
                  formControlName="campusSlug"
                  class="field__input field__input--sm"
                  [placeholder]="'HUBS.CAMPUS_SLUG_PLACEHOLDER' | translate"
                />
              </div>

              <div class="field__group">
                <label
                  class="field__label field__label--sm"
                  for="hub-tenant-id"
                >
                  {{ 'HUBS.TENANT_ID' | translate }}
                </label>
                <p class="field__hint">
                  {{ 'HUBS.TENANT_ID_HINT' | translate }}
                </p>
                <input
                  id="hub-tenant-id"
                  formControlName="tenantId"
                  class="field__input field__input--sm"
                  [placeholder]="'HUBS.TENANT_ID_PLACEHOLDER' | translate"
                />
              </div>
            </div>

            <div class="hub-create-modal__section-title">
              {{ 'HUBS.FEATURES_TITLE' | translate }}
            </div>
            <div class="hub-create-modal__toggles">
              <div class="hub-create-modal__toggle-row">
                <mat-slide-toggle formControlName="hasCourse" color="primary">
                  {{ 'HUBS.HAS_COURSE' | translate }}
                </mat-slide-toggle>
              </div>
              <div class="hub-create-modal__toggle-row">
                <mat-slide-toggle
                  formControlName="hasCaremonitor"
                  color="primary"
                >
                  {{ 'HUBS.HAS_CAREMONITOR' | translate }}
                </mat-slide-toggle>
              </div>
              <div class="hub-create-modal__toggle-row">
                <mat-slide-toggle formControlName="hasNewCase" color="primary">
                  {{ 'HUBS.HAS_NEW_CASE' | translate }}
                </mat-slide-toggle>
              </div>
            </div>

            <div class="hub-create-modal__section-title">
              {{ 'HUBS.SETTINGS_TITLE' | translate }}
            </div>
            <div
              class="hub-create-modal__toggles hub-create-modal__toggles--grid"
            >
              @for (setting of settingKeys; track setting.key) {
                <div class="hub-create-modal__toggle-row">
                  <mat-slide-toggle
                    [formControlName]="setting.key"
                    color="primary"
                  >
                    {{ setting.label | translate }}
                  </mat-slide-toggle>
                </div>
              }
            </div>
          </form>
        </div>
      </section>
    }

    <!-- ── Tab 3: Location & Contacts ── -->
    @case (2) {
      <section class="modal-panel">
        <header class="modal-panel__header">
          <h5 class="modal-panel__title">
            {{ 'HUBS.STEP_LOCATION' | translate }}
          </h5>
        </header>

        <div class="modal-panel__body" (focusin)="scrollFieldIntoView($event)">
          <form class="field__form" [formGroup]="formGroup">
            <div class="field__group">
              <label class="field__label field__label--sm" for="hub-address">
                {{ 'EVENTS.LOCATION' | translate }}
              </label>
              <p class="field__hint">
                {{ 'EVENTS.LOCATION_HINT' | translate }}
              </p>
              <input
                id="hub-address"
                formControlName="location"
                class="field__input field__input--sm"
                [placeholder]="'EVENTS.LOCATION_PLACEHOLDER' | translate"
                autocomplete="off"
                appPlacesAutocomplete
                (input)="onLocationInput($any($event.target).value)"
                (placePicked)="onPlacePicked($event)"
              />
            </div>
          </form>

          <!-- Contacts — managed outside the reactive form -->
          <div
            class="hub-create-modal__section-title hub-create-modal__section-title--spaced"
          >
            {{ 'HUBS.CONTACTS_TITLE' | translate }}
          </div>

          @for (contact of contacts; track $index) {
            <div class="hub-create-modal__contact-row">
              <mat-select
                [(ngModel)]="contact.type"
                class="field__input field__input--sm hub-create-modal__contact-type"
              >
                @for (ct of contactTypes; track ct) {
                  <mat-option [value]="ct">
                    {{ 'HUBS.CONTACT_TYPE_' + ct | translate }}
                  </mat-option>
                }
              </mat-select>
              <input
                [(ngModel)]="contact.value"
                [type]="contact.type === HubContactType.EMAIL ? 'email' : 'tel'"
                class="field__input field__input--sm hub-create-modal__contact-value"
                [placeholder]="'HUBS.CONTACT_VALUE' | translate"
              />
              <button
                type="button"
                class="btn btn--ssm btn--danger btn--ico-only"
                (click)="removeContact($index)"
              >
                <fa-icon [icon]="['fass', 'trash']"></fa-icon>
              </button>
            </div>
          }

          <button
            type="button"
            class="btn btn--sm btn--outline"
            (click)="addContact()"
          >
            <fa-icon [icon]="['fass', 'plus']" aria-hidden="true"></fa-icon>
            <span>{{ 'HUBS.ADD_CONTACT' | translate }}</span>
          </button>
        </div>
      </section>
    }

    <!-- ── Tab 4: Images & Policies ── -->
    @case (3) {
      <section class="modal-panel">
        <header class="modal-panel__header">
          <h5 class="modal-panel__title">
            {{ 'HUBS.STEP_MEDIA' | translate }}
          </h5>
        </header>

        <div class="modal-panel__body" (focusin)="scrollFieldIntoView($event)">
          <div class="hub-create-modal__section-title">
            {{ 'IMAGE' | translate }}
          </div>

          <div class="field__row">
            <app-file-cropper
              #logoCropper
              [label]="'FILE_SELECT_LOGO_TITLE'"
              [placeholder]="'HUBS.UPLOAD_LOGO'"
              [acceptTypes]="[fileTypes.IMAGE]"
              (removeFileChange)="removeFile($event)"
              (confirmFileChange)="confirmFile($event, imageTypes.LOGO)"
              [file]="getImage(imageTypes.LOGO)"
              [aspectRatio]="1 / 1"
            ></app-file-cropper>

            <app-file-cropper
              #thumbnailCropper
              [label]="'FILE_SELECT_THUMBNAIL_TITLE'"
              [placeholder]="'HUBS.UPLOAD_THUMBNAIL'"
              [acceptTypes]="[fileTypes.IMAGE]"
              (removeFileChange)="removeFile($event)"
              (confirmFileChange)="confirmFile($event, imageTypes.THUMBNAIL)"
              [file]="getImage(imageTypes.THUMBNAIL)"
              [aspectRatio]="16 / 9"
            ></app-file-cropper>

            <app-file-cropper
              #coverCropper
              [label]="'FILE_SELECT_COVER_TITLE'"
              [placeholder]="'HUBS.UPLOAD_COVER'"
              [acceptTypes]="[fileTypes.IMAGE]"
              (removeFileChange)="removeFile($event)"
              (confirmFileChange)="confirmFile($event, imageTypes.BACKGROUND)"
              [file]="getImage(imageTypes.BACKGROUND)"
              [aspectRatio]="3 / 1"
            ></app-file-cropper>
          </div>

          <!-- Policies as HUB_POLICY and HUB_TERMS settings -->
          <div
            class="hub-create-modal__section-title hub-create-modal__section-title--spaced"
          >
            {{ 'HUBS.POLICIES_TITLE' | translate }}
          </div>

          <div class="field__group">
            <label class="field__label field__label--sm">
              {{ 'HUBS.POLICY_LABEL' | translate }}
            </label>
            <p class="field__hint">{{ 'HUBS.POLICY_HINT' | translate }}</p>
            <quill-editor
              [(ngModel)]="policyContent"
              [modules]="richTextModules"
              [formats]="richTextFormats"
              [placeholder]="'HUBS.POLICY_BODY_PLACEHOLDER' | translate"
            ></quill-editor>
          </div>

          <div class="field__group">
            <label class="field__label field__label--sm">
              {{ 'HUBS.TERMS_LABEL' | translate }}
            </label>
            <p class="field__hint">{{ 'HUBS.TERMS_HINT' | translate }}</p>
            <quill-editor
              [(ngModel)]="termsContent"
              [modules]="richTextModules"
              [formats]="richTextFormats"
              [placeholder]="'HUBS.POLICY_BODY_PLACEHOLDER' | translate"
            ></quill-editor>
          </div>
        </div>
      </section>
    }
  }
</app-modal>
